module.exports = __webpack_public_path__ + "static/media/Scaramella-Brush.d2e30ff4.otf";